import React, { useEffect } from 'react'
import { Modal } from '@siftscience/focus-components/modal'
import { Action } from '@siftscience/focus-components/action-bar'
import { Text } from '@siftscience/focus-components/text'
import { Send } from '@siftscience/focus-components/icons/Send'
import { ButtonVariant } from '@siftscience/focus-components/button'
import { makeStyles } from '@material-ui/core/styles'
import { Code } from 'react-content-loader'
import { useDisputesAffected } from '../hooks/useDisputesAffected'
import { useMerchantContext } from '../context/merchant-context'

const MODAL_ACTION_LABEL = {
  save: 'Save Changes',
  cancel: 'Cancel'
}

const MODAL_ACTIONS: Action[] = [
  {
    label: (
      <>
        <Send />
        <span>{MODAL_ACTION_LABEL.save}</span>
      </>
    ),
    size: 'medium',
    id: MODAL_ACTION_LABEL.save
  },
  {
    label: MODAL_ACTION_LABEL.cancel,
    variant: 'secondary' as ButtonVariant,
    size: 'medium',
    lined: true,
    id: MODAL_ACTION_LABEL.cancel
  }
]

const useStyles = makeStyles(() => ({
  modalContent: {
    overflow: 'scroll'
  },
  modalFooterContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '8px'
  }
}))

export interface DisputesAffectedModalProps {
  onClose: () => void
  onSave: () => void
  templateId: number
}

const DisputesAffectedModal = ({
  onClose,
  onSave,
  templateId
}: DisputesAffectedModalProps) => {
  const { selectedMerchant } = useMerchantContext()
  const { count: disputesAffectedCount, isLoading } = useDisputesAffected(
    templateId,
    selectedMerchant.id
  )
  const classes = useStyles()

  useEffect(() => {
    if (disputesAffectedCount === 0) {
      // Autosave if there are no disputes affected
      onSave()
      onClose()
    }
  }, [disputesAffectedCount])

  const onModalAction = (action: Action) => {
    if (action.id === MODAL_ACTION_LABEL.cancel) {
      onClose()
      return
    }
    if (action.id === MODAL_ACTION_LABEL.save) {
      onSave()
      onClose()
    }
  }

  if (isLoading) {
    return null
  }

  return (
    <div className="det-modal">
      <Modal
        contentContainerClassName={classes.modalContent}
        variant="fixed"
        title={'Apply Changes'}
        onCloseButtonClick={onClose}
        onClickOutside={onClose}
        actions={MODAL_ACTIONS}
        onAction={onModalAction}
        size="medium"
      >
        {isLoading ? (
          <Code height={150} style={{ width: '100%', padding: '16px' }} />
        ) : (
          <Text>
            Your changes will affect {disputesAffectedCount} disputes. Are you
            sure you want to proceed?
          </Text>
        )}
      </Modal>
    </div>
  )
}

export default DisputesAffectedModal
